import { render, staticRenderFns } from "./ElCheckbox.vue?vue&type=template&id=27060f4a&scoped=true&"
import script from "./ElCheckbox.vue?vue&type=script&lang=js&"
export * from "./ElCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./ElCheckbox.vue?vue&type=style&index=0&id=27060f4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27060f4a",
  null
  
)

export default component.exports